import { VueModule } from '@Foundation';
import ProvenBenefits from './code/Scripts/components/proven-benefits';

export default VueModule({
  components: {
    ProvenBenefits
  }
});
